function maskRefPayco(ref) {
  if (!ref || typeof ref !== "string") {
    return undefined;
  }
  if (ref.length <= 4) {
    return "***";
  }
  return "***" + ref.slice(-4);
}

function sanitizeEndpoint(endpoint) {
  if (!endpoint || typeof endpoint !== "string") {
    return endpoint;
  }

  try {
    const url = new URL(endpoint, window.location.origin);
    return url.pathname;
  } catch (e) {
    const withoutQuery = endpoint.split("?")[0];
    return withoutQuery.replace(/^https?:\/\/[^/]+/, "") || withoutQuery;
  }
}

export function logIntegrationError({
  flow,
  service,
  endpoint,
  errorType,
  statusCode,
  refPayco,
  extra = {},
}) {
  const payload = {
    type: "integration_error",
    flow,
    service,
    endpoint: sanitizeEndpoint(endpoint),
    errorType,
    statusCode: statusCode || undefined,
    proyecto: sessionStorage.getItem("proyecto") || undefined,
    refPayco: maskRefPayco(refPayco),
    timestamp: new Date().toISOString(),
    ...extra,
  };

  console.error("[integration_error]", JSON.stringify(payload));
}
